import React from "react";

const Memory_Address = () => {
  return (
    <div>
      <h1>Memory_Address Component</h1>
      <p>Content for Memory_Address goes here...</p>
    </div>
  );
};

export default Memory_Address;
